// Utils
import { isMultiSelectListItemSelected } from '../utils/multi-select-list-utils';
import * as i0 from "@angular/core";
/**
 * Is Multi Select List Item Selected Pipe
 *
 * Checks if an item in the MultiSelectListComponent is currently selected.
 */
export class isMultiSelectListItemSelectedPipe {
    transform(item, selectedItems, activeSecurityGroupTab) {
        return isMultiSelectListItemSelected(item, selectedItems, activeSecurityGroupTab);
    }
}
isMultiSelectListItemSelectedPipe.ɵfac = function isMultiSelectListItemSelectedPipe_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || isMultiSelectListItemSelectedPipe)(); };
isMultiSelectListItemSelectedPipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "isMultiSelectListItemSelected", type: isMultiSelectListItemSelectedPipe, pure: true, standalone: false });
